import { useToast } from 'vue-toastification'
import { getApiErrorMessage } from '@/utils/apiError'
import { API_ERROR_MESSAGES } from '@/constants/errorMessages'

/**
 * Porta canônica para toasts de erro (rule `error-handling.md`).
 * Código novo NÃO deve chamar `toast.error` direto — use este composable.
 */
export function useErrorToast() {
  const toast = useToast()

  /** Notifica um erro de API: extrai a mensagem exibível via `getApiErrorMessage`. */
  function notifyError(error: unknown, fallback: string = API_ERROR_MESSAGES.GENERIC_ERROR): void {
    toast.error(getApiErrorMessage(error, fallback))
  }

  /** Notifica uma mensagem de erro já pronta (validações locais, regras de UI). */
  function notifyErrorMessage(message: string): void {
    toast.error(message)
  }

  return { notifyError, notifyErrorMessage }
}
